import lazyLoading from './lazyLoading'

export default {
  name: 'tools',
  meta: {
    expanded: false,
    title: 'Herramientas',
    iconClass: 'vuestic-icon vuestic-icon-statistics'
  },
  children: [
    {
      name: 'processDay',
      path: '/utils/process-day',
      component: lazyLoading('tools/ProcessDay'),
      meta: {
        title: 'Proceso del Día',
        requiresAuth: true
      }
    },
    {
      name: 'processDayAerotaxi',
      path: '/utils/process-day-aerotaxi',
      component: lazyLoading('tools/ProcessDayAerotaxi'),
      meta: {
        title: 'Proceso del Día Aerotaxi',
        requiresAuth: true
      }
    },
    {
      name: 'reportCreditCard',
      path: '/utils/report-credit-card',
      component: lazyLoading('tools/reportCards'),
      meta: {
        title: 'Subir Reporte Mensual de EBSA',
        requiresAuth: true
      }
    },
    {
      name: 'uploadZone',
      path: '/utils/upload-zone',
      component: lazyLoading('tools/uploadZone'),
      meta: {
        title: 'Subir Zonas',
        requiresAuth: true
      }
    },
    {
      name: 'uploadRate',
      path: '/utils/upload-rate',
      component: lazyLoading('tools/uploadRate'),
      meta: {
        title: 'Subir Tarifas',
        requiresAuth: true
      }
    },
    {
      name: 'saleMonthList',
      path: '/utils/sale-month-list',
      component: lazyLoading('tools/SaleMonthList'),
      meta: {
        title: 'Listado de ventas',
        requiresAuth: true
      }
    },
    /*
    {
      name: 'usersWithoutOpenpay',
      path: '/utils/users-without-openpay',
      component: lazyLoading('tools/usersWithoutOpenpay'),
      meta: {
        title: 'Usuario sin Openpay',
        requiresAuth: true
      }
    },
    {
      name: 'load-information',
      path: '/utils/load-information',
      component: lazyLoading('tools/loadInformation'),
      meta: {
        title: 'Cargar Información',
        requiresAuth: true
      }
    },
    {
      path: '/utils/duplicated-travels',
      component: lazyLoading('tools/DuplicatedTravels'),
      meta: {
        title: 'Viajes Duplicados'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('tools/DuplicatedTravels'),
          meta: {
            title: 'Viajes Duplicados',
            requiresAuth: true
          }
        },
        {
          path: ':travelId',
          component: lazyLoading('tools/DuplicatedTravel'),
          props: true,
          meta: {
            title: 'Viajes Duplicado Detalles',
            requiresAuth: true
          }
        }
      ]
    }
    */
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/tools.js